export default {
    DELETE: "Удалить",
    APPEND_TO_GRAPH: "Отправить на граф",
    SELECT_FOR_APPEND_TO_GRAPH: "Выделите текст для отправки на граф"
};
